import { type SyntheticEvent } from "react"

import {
  selectAuthFlowEmail,
  selectAuthFlowError,
  selectAuthFlowForgotPasswordStep,
  selectAuthFlowForgotPasswordSubmitting,
  setAuthFlowEmail,
} from "@/lib/storage/auth-slice"
import {
  handleForgotPasswordGoToSignIn,
  handleForgotPasswordSubmit,
} from "@/lib/storage/auth-thunks"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import { Button } from "../ui/button"
import { Form, FormControl, FormError, FormField } from "../ui/form"
import { TextInput } from "../ui/text-input"

export default function ForgottenPasswordComponent() {
  const dispatch = useAppDispatch()
  const email = useAppSelector(selectAuthFlowEmail)
  const errorMessage = useAppSelector(selectAuthFlowError)
  const submitting = useAppSelector(selectAuthFlowForgotPasswordSubmitting)
  const step = useAppSelector(selectAuthFlowForgotPasswordStep)

  const handleForgottenPassword = async (
    e: SyntheticEvent<HTMLFormElement>
  ) => {
    e.preventDefault()
    void dispatch(handleForgotPasswordSubmit())
  }

  const goToSignin = () => {
    void dispatch(handleForgotPasswordGoToSignIn({ email }))
  }

  return (
    <>
      {step === "mismatch" ? (
        <Button variant="primary" size="lg" block onClick={goToSignin}>
          Log in
        </Button>
      ) : null}

      {step === "success" ? (
        <p className="leading-normal">
          You got it! If {email} is tied to an account, we{"'"}ve emailed a
          reset link. Take a look in your inbox and find the link to give your
          password a fresh start.
        </p>
      ) : null}

      {step === "form" && (
        <>
          {errorMessage && (
            <p className="mt-2 font-medium text-destructive">{errorMessage}</p>
          )}
          <Form method="post" onSubmit={handleForgottenPassword}>
            <FormField name="email">
              <FormControl
                render={
                  <TextInput
                    required
                    type="email"
                    placeholder="Email"
                    autoComplete="username"
                    defaultValue={email || undefined}
                    size="lg"
                    onChange={(e) => dispatch(setAuthFlowEmail(e.target.value))}
                    disabled={submitting}
                  />
                }
              />
              <FormError match="typeMismatch">
                Please provide a valid email
              </FormError>
            </FormField>
            <Button
              type="submit"
              variant="primary"
              size="lg"
              block
              loading={submitting}
            >
              Continue
            </Button>
          </Form>
        </>
      )}
    </>
  )
}
